// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"9d87a93a","5071":"9d87a93a","6419":"9d87a93a","7395":"9d87a93a","7502":"9d87a93a","8801":"9d87a93a"}[chunkId] + ".chunk.css";
};